export default __webpack_public_path__ + "static/media/6.39cbf348.jpg";